import { render } from "./mapIcon.vue?vue&type=template&id=58521bba"
import script from "./mapIcon.vue?vue&type=script&lang=js"
export * from "./mapIcon.vue?vue&type=script&lang=js"

import "./mapIcon.vue?vue&type=style&index=0&id=58521bba&lang=scss"

import exportComponent from "/codebuild/output/src354116273/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__